<template>
  <v-layout fill-height
            align-center
            justify-center
            class="black--text"
            :class="`${bgColor}`"
            wrap
            @click="show(event)">
            <p ><span>{{event.ScheduleStart | formatDate}}-{{event.ScheduleEnd | formatDate}}</span></p>

  </v-layout>
</template>
<script>

import { createNamespacedHelpers } from 'vuex'
import confirmDialog from '@/components/confirmDialog'
import { formatDate, getNextDate, isContinous } from '@/utils/date.js'
const namespace = 'processTraining'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)
export default {
  props: ['info'],
  filters: { 
    formatDate (time) {
      let date = new Date(time)
      return formatDate(date, 'hh:mm')
    }
   },

  watch:{
      
  },
  computed: {
    ...mapGetters([ 'canSubmit', 'selects']),
    event () {
      return {
        ScheduleStart: this.info.event.extendedProps.ScheduleStart,
        ScheduleEnd: this.info.event.extendedProps.ScheduleEnd,
        Status: this.info.event.extendedProps.Status
      }
    },
    bgColor () {
      if (this.event.Status === 'Waited') {
        return 'amber lighten-3'
      } else {
        return 'amber lighten-5'
      }
    },
    selects () {
      return this.$store.state[namespace].selects
    },
    canSubmit () {
      return this.$store.state[namespace].canSubmit
    }
  },
  methods: {
    show (event) {
        event.Status = event.Status == ''?'Waited':''
        this.$store.dispatch(`${namespace}/upEvents`, event)
    }
    
  }
}
</script>
